export default {
  BILLING: 'BILLING',
  DISPATCH: 'DISPATCH',
  PROJECT: 'PROJECT',
};
